/* import __COLOCATED_TEMPLATE__ from './scroll-wheel-zoom-toggle.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import type Graph from '../../../models/graph-editor/graph';

interface Args {
  graph: Graph;
}

export default class GraphEditorControlsScrollWheelZoomToggleComponent extends Component<Args> {
  @action toggleScrollWheelZoomMode(): void {
    this.args.graph.settings.scroll.toggleScrollWheelZoomMode();
  }
}
